export type OptionalColumnMappingKey = 'primaryManagerId' | 'highLevelManagerId' | 'coManagerIds' | 'deletedIndicator'
type ManagerColumnMappingKey = Exclude<OptionalColumnMappingKey, 'deletedIndicator'>

const managerColumnMappingKeys: ManagerColumnMappingKey[] = ['primaryManagerId', 'highLevelManagerId', 'coManagerIds']

export type DataFeedColumnMappingFormSlice = Record<
	'firstName' | 'lastName' | 'email' | 'externalId' | OptionalColumnMappingKey,
	string
>

export const defaultColumnMappingFormValues: DataFeedColumnMappingFormSlice = {
	firstName: 'First Name',
	lastName: 'Last Name',
	email: 'Email',
	externalId: 'External ID',
	primaryManagerId: '',
	highLevelManagerId: '',
	coManagerIds: '',
	deletedIndicator: '',
}

export const getColumnMappingFormValues = (
	columnMapping?: Partial<DataFeedColumnMappingFormSlice> | null,
): DataFeedColumnMappingFormSlice =>
	Object.fromEntries(
		Object.entries(defaultColumnMappingFormValues).map(([key, defaultValue]) => [
			key,
			columnMapping?.[key as keyof DataFeedColumnMappingFormSlice] || defaultValue,
		]),
	) as DataFeedColumnMappingFormSlice

const optionalColumnMapping = (key: OptionalColumnMappingKey, value: string) => {
	const trimmed = value.trim()
	return trimmed ? { [key]: trimmed } : {}
}

export const hasManagerColumnMapping = (values: Record<ManagerColumnMappingKey, string>) =>
	managerColumnMappingKeys.some((key) => values[key].trim().length > 0)

export const buildColumnMappingPayload = (values: DataFeedColumnMappingFormSlice) => ({
	firstName: values.firstName,
	lastName: values.lastName,
	email: values.email,
	externalId: values.externalId,
	...optionalColumnMapping('primaryManagerId', values.primaryManagerId),
	...optionalColumnMapping('highLevelManagerId', values.highLevelManagerId),
	...optionalColumnMapping('coManagerIds', values.coManagerIds),
	...optionalColumnMapping('deletedIndicator', values.deletedIndicator),
})
